export default "__VITE_ASSET__ERcaHUo2__"